import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import rbush from "geojson-rbush";
import { delay } from "lodash";

import { DRAWING_CONSTANTS } from "fond/constants";
import { clearSnapIndicator, updateSnapIndicator } from "fond/draw/snapIndicator";
import { feature as toFeature } from "fond/turf";

import drawLineStringMode from "../../base/drawLineString";

import { isValid, pullInPoints } from "./helper";

/**
 * This is a custom mode for drawing ug paths in FOND Planner Extended.
 * It extends the draw_lineString mode and adds validation for ug points.
 */
const drawLineString: DrawCustomMode = {
  ...drawLineStringMode,

  onMouseMove: function (this, state, e) {
    drawLineStringMode.onMouseMove?.call(this, state, e);

    const sourceId = state.options?.snapIndicatorSource;
    if (sourceId && state.snappedLng !== undefined && state.snappedLat !== undefined) {
      updateSnapIndicator(this.map, sourceId, state.snappedLng, state.snappedLat, e);
    }
  },

  onStop: function (this, state) {
    const sourceId = state.options?.snapIndicatorSource;
    if (sourceId) clearSnapIndicator(this.map, sourceId);

    drawLineStringMode.onStop?.call(this, state);

    // We allow the line to be created first, then we refresh all colocated
    // points valid property.
    delay(() => {
      const tree = rbush();
      tree.load(this._ctx.api.getAll());
      pullInPoints.call(this, toFeature(state.line)).forEach((f) => {
        if (f.id) this._ctx.api.setFeatureProperty(f.id, DRAWING_CONSTANTS.Valid, isValid(f, tree).toString());
        this.doRender(f.id);
      });
    }, 0);
  },
};

export default drawLineString;
